var base = require('settings/teams/team-membership');

Vue.component('spark-team-membership', {
    mixins: [base],
    data() {
      return {
        showSendInvitationModal: false
      }
    },
    methods: {
      closeModal() {
        this.showSendInvitationModal = false;
      }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/spark-components/settings/teams/team-membership.js